import { Slot } from "../../Model";
import { BarberRepository } from "../../Repository";

export async function slotSelected(
  slot: Slot | null,
  repository: BarberRepository
): Promise<void> {
  return repository.setSelectedSlot(slot);
}
